module.exports = __webpack_public_path__ + "img/fr.2b123f26.svg";